import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

import { getSingleInvitation } from "~/lib/payload/invitations";

const useAuthFlowCodes = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [searchParams] = useSearchParams();

  const invitation = searchParams.get("invitation");
  const token = searchParams.get("token");

  useEffect(() => {
    if (invitation && token) {
      setIsLoading(true);

      const verifyUser = async () => {
        const { success, data } = await getSingleInvitation({
          invitation,
          token,
        });

        if (success) {
          setFirstName(data.firstName);
          setLastName(data.lastName);
          setEmail(data.email);
        }

        setIsLoading(false);
      };

      verifyUser();
    }
  }, [invitation, token]);

  return { isLoading, email, firstName, lastName };
};

export default useAuthFlowCodes;
